import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import style from './SidebarItem.module.scss';

interface ISidebarItem {
	onClick: () => void;
	label: string;
	isActive: boolean;
}

const SidebarItem: React.FC<ISidebarItem> = ({ label, isActive, onClick }) => {
	const labelClasses = classNames(style.label, { [style.active]: isActive });

	return (
		<div className={labelClasses} onClick={onClick}>
			<Text
				translationNameSpace="mediaSettings"
				translationKey={label}
				theme={!isActive ? 'accent' : 'contrast'}
				size="s"
				weight="bold"
				withTooltip={true}
			/>
		</div>
	);
};

export default SidebarItem;
